export const COEFFICIENTS = {
  age: 0.0113,
  sex: -0.0786,
  nstemi: 0.5366,
  eGFR: -0.0049,
  hemo: -0.0011,
  albuminuriaMild: 0.0215,
  albuminuriaHEavy: 0.2143,
  charlsonCHF: 0.2163,
  charlsonCOPD: 0.0289,
  charlsonPVD: 0.1664,
  diabetes: 0.1737,
  priorInv: 0.6600
};

export const BASELINES = {
  age: -77.14,
  eGFR: -51.41,
  hemo: -126.74
};

export const FACTOR = {
  conservativeMgmt: 1 / 0.79
};
